module.exports = __webpack_public_path__ + "static/forecast/weather/dayclear-aa62fb5b50cd48df607367a15d81b483.svg";